(function () {
  'use strict';

  function initNovitaFeed(root) {
    var viewport = root.querySelector('[data-novita-viewport]');
    var track = root.querySelector('[data-novita-track]');
    if (!viewport || !track) return;

    var pointerActive = false;
    var dragStarted = false;
    var startX = 0;
    var startTranslate = 0;
    var currentTranslate = 0;
    var resumeTimer = null;
    var DRAG_THRESHOLD = 6;
    var RESUME_DELAY = 3000;

    function getTranslateX(el) {
      var style = window.getComputedStyle(el);
      var transform = style.transform;
      if (!transform || transform === 'none') return 0;
      var matrix = transform.match(/^matrix\(([^)]+)\)$/);
      if (matrix) {
        var parts = matrix[1].split(',').map(Number);
        return parts[4] || 0;
      }
      return 0;
    }

    function beginManualControl() {
      clearTimeout(resumeTimer);
      currentTranslate = getTranslateX(track);
      track.style.animation = 'none';
      track.style.transform = 'translateX(' + currentTranslate + 'px)';
      viewport.classList.add('is-dragging');
    }

    function scheduleResume() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        viewport.classList.remove('is-dragging');
        track.style.animation = '';
        track.style.transform = '';
      }, RESUME_DELAY);
    }

    function pointerX(e) {
      return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
    }

    function onPointerDown(e) {
      pointerActive = true;
      dragStarted = false;
      startX = pointerX(e);
    }

    function onPointerMove(e) {
      if (!pointerActive) return;
      var delta = pointerX(e) - startX;

      if (!dragStarted) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        dragStarted = true;
        beginManualControl();
        startTranslate = currentTranslate;
      }

      currentTranslate = startTranslate + delta;
      track.style.transform = 'translateX(' + currentTranslate + 'px)';
    }

    function onPointerUp() {
      if (!pointerActive) return;
      pointerActive = false;
      if (!dragStarted) return;
      dragStarted = false;
      scheduleResume();

      var suppressClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
      };
      track.addEventListener('click', suppressClick, { capture: true, once: true });
    }

    viewport.addEventListener('mousedown', onPointerDown);
    viewport.addEventListener('touchstart', onPointerDown, { passive: true });
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: true });
    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);

    viewport.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) return;
        e.preventDefault();
        beginManualControl();
        currentTranslate = currentTranslate - e.deltaX;
        track.style.transform = 'translateX(' + currentTranslate + 'px)';
        scheduleResume();
      },
      { passive: false }
    );
  }

  document.querySelectorAll('[data-novita-feed]').forEach(initNovitaFeed);
})();
